import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IBaseSearchRequest, IPagedResults } from 'src/app/core/models/base';
import { environment } from 'src/environments/environment';
import { ICreateRessourceRequest, IRessource, ISearchRessourceRequest } from '../models/ressource';

@Injectable({
  providedIn: 'root'
})
export class RessourceService {

  constructor(private http: HttpClient) { }

   searchRessources(request: ISearchRessourceRequest = {pageSize: 999999, pageNumber: 0}){
    return this.http.post<IPagedResults<IRessource[]>>(
      `${environment.baseUrl}/v1/Ressource/searchRessources`,
      request
    )
  }

  getRessource(id: string){
    return this.http.get<string>(
      `${environment.baseUrl}/v1/Ressource/createRessource/${id}`
    )
  }

  createRessource(request: ICreateRessourceRequest){
    return this.http.post<string>(
      `${environment.baseUrl}/v1/Ressource/createRessource`,
      request
    )
  }

  updateRessource(request: IRessource){
    return this.http.put<string>(
      `${environment.baseUrl}/v1/Ressource/updateRessource/${request.id}`,
      request
    )
  }

  deleteRessource(id: string){
    return this.http.delete<string>(
      `${environment.baseUrl}/v1/Ressource/deleteRessource/${id}`
    )
  }
}
